import { combineReducers } from "redux";
import loadData from "./load_regulation.reducer";


/**
 * 智慧用能Reducer
 */
const smartEnergyReducer = combineReducers({
    loadData,  // 负荷数据
})

export default smartEnergyReducer;
